import { Helper } from "./helper";
import { Requester } from "./requester";
import { Txt } from "./text";
import { MessageDisplayer } from "./message-displayer";
import { Loader } from "./loader";
import { Form, FormDisplayer } from "../forms/form";

export class ConfirmationDialogHelper
{
    static showDialog(confirmationMessage: string, url: string, onSuccess: () => void): void
    {
        async function confirmAction()
        {
            try
            {
                Loader.startGlobally();
                const result = await Requester.get(url);
                if (result.NewFormUrl)
                {
                    const form = new Form(result.NewFormUrl);
                    form.onDataChanged = () => onSuccess();
                    await FormDisplayer.openInModal(form);
                    return;
                }
                onSuccess();
                MessageDisplayer.showDialog(result);
            }
            catch (error)
            {
                MessageDisplayer.showErrorFromServer(error);
            }
            finally
            {
                Loader.stopGlobally();
            }
        }

        if (!Helper.hasValue(confirmationMessage))
        {
            confirmAction();
        }
        else
        {
            const params: any = this.getParams(confirmationMessage);
            params.preConfirm = confirmAction;
            MessageDisplayer.fireAlert(params);
        }
    }

    static askConfirmation(confirmationMessage: string, onConfirmation: () => void, onCancel?: () => void): void
    {
        MessageDisplayer.fireAlert(this.getParams(confirmationMessage)).then(result =>
        {
            if (result.isConfirmed)
            {
                onConfirmation();
            }
            else if (onCancel)
            {
                onCancel();
            }
        });
    }

    private static getParams(confirmationMessage: string)
    {
        return {
            title: Txt.areYouSure,
            text: confirmationMessage,
            imageUrl: "images/question.png",
            showCancelButton: true,
            confirmButtonText: Txt.yes,
            cancelButtonText: Txt.no,
            reverseButtons: true
        };
    }
}
